import { render, staticRenderFns } from "./AdminOrderPrintPreview.vue?vue&type=template&id=bb0e7568&scoped=true&"
import script from "./AdminOrderPrintPreview.vue?vue&type=script&lang=js&"
export * from "./AdminOrderPrintPreview.vue?vue&type=script&lang=js&"
import style0 from "./AdminOrderPrintPreview.vue?vue&type=style&index=0&id=bb0e7568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0e7568",
  null
  
)

export default component.exports